import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-main px-5 py-16 md:py-24" data-id="element-42" data-mp="1nvb93tn9u12g">
      <Reveal className="mx-auto max-w-3xl" data-id="element-43" data-mp="2bjub5rfq9hm3">
        <div className="mb-12 text-center" data-id="element-44" data-mp="2bl5l68zrnlln">
          <Eyebrow data-id="element-45" data-mp="2fmh4xxvylclx">Gut zu wissen</Eyebrow>
          <h2 className="mt-5 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-46" data-mp="2flfthsb16o3o">
            Häufig gestellte Fragen
          </h2>
        </div>
        <div className="space-y-3" data-id="element-47" data-mp="26tdw62w9dnxm">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-brand-line bg-brand-alt shadow-sm" data-id="element-48" data-mp="2z9ydlvh6jbbi" data-mpi={index}>
                <h3 data-id="element-49" data-mp="1vnooin4zvdmf">
                  <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-display text-base font-bold text-brand-navy transition-colors duration-150 ease-out hover:bg-brand-main focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-orange md:text-lg" data-id="element-50" data-mp="1ro655vstnalp">
                    <span data-id="element-51" data-mp="2odwz9tx7avqz">{faq.question}</span>
                    {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-52" data-mp="2jgetudie6ynq" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-53" data-mp="p2dyi2m1wtse" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-54" data-mp="2u4rhkv7keorj">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-55" data-mp="2z06u9jtu6emd">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-56" data-mp="3mrcj2ohr8h8t">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}